module.exports = __webpack_public_path__ + "img/notice-image.922bd885.svg";